import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RepayMarkAsFailedEvent = BaseLoanEvent.extend({
  type: z.literal('repayMarkAsFailed'),
  paymentId: PaymentId,
  failureCode: z.string().optional(),
});
export type RepayMarkAsFailedEvent = z.infer<typeof RepayMarkAsFailedEvent>;
